import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Components
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';

import { FeatureModule } from 'v2/shared/feature/feature.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';

// LIB

// MODULES
import { FilterModule } from '../filter/filter.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { UiModule } from '../ui/ui.module';

import { DirectiveModule } from './../shared/directives/directive.module';
import {
  LocationWarehouseGroupComponent,
  LocationWarehouseGroupFilterComponent,
  LocationWarehouseGroupPopupComponent,
  LocationWarehouseGroupTableComponent,
  LocationWarehouseAppComponent,
  LocationWarehouseAppScannerComponent,
  LocationWarehouseAppScannerDevicesComponent,
  LocationWarehouseSelectionComponent,
  LocationWarehouseQuantityEntryComponent,
  LocationWarehouseAppSkuSelectionComponent,
  LocationWarehouseAppPicklistTotalComponent,
  LocationWarehouseAppScannerPopupBarcodeComponent,
  LocationWarehouseSkuTransferComponent,
} from './components';

// Components
const components = [
  LocationWarehouseGroupComponent,
  LocationWarehouseGroupFilterComponent,
  LocationWarehouseGroupPopupComponent,
  LocationWarehouseGroupTableComponent,
  LocationWarehouseAppComponent,
  LocationWarehouseAppScannerComponent,
  LocationWarehouseAppScannerDevicesComponent,
  LocationWarehouseSelectionComponent,
  LocationWarehouseQuantityEntryComponent,
  LocationWarehouseAppSkuSelectionComponent,
  LocationWarehouseAppPicklistTotalComponent,
  LocationWarehouseAppScannerPopupBarcodeComponent,
  LocationWarehouseSkuTransferComponent,
];

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  ClipboardModule,
];

const lumModules = [
  FilterModule,
  SharedComponentsModule,
  PipeModule,
  DirectiveModule,
  MaterialCustomModule,
  UiModule,
  FeatureModule,
];

const libModules = [NgxScannerQrcodeModule];

@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...lumModules, ...libModules],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class LocationModule {}
